<template>
  <footer class="bg-slate-50 py-16">
    <div class="grid grid-cols-2 md:tw-flex md:justify-between items-start w-full px-8 max-w-7xl mx-auto">
      <div class="col-span-2 md:col-span-1 mb-10 md:mb-0">
        <div class="text-lg font-black text-slate-900 mb-4 w-36"><img src="/images/logos/foodleap-dark.png"></div>
        <p class="text-sm text-slate-600 max-w-[240px]">
          Shaping the future of food together
        </p>
      </div>
      <div class="tw-flex flex-col gap-4">
        <h5 class="text-slate-900 font-semibold">Product</h5>
        <a class="text-sm text-slate-500 hover:text-fp-primary transition-colors no-underline" @click="$router.push('/intelligence')">Intelligence</a>
      </div>
      <div class="tw-flex flex-col gap-4">
        <h5 class="text-slate-900 font-semibold">Company</h5>
        <a class="text-sm text-slate-500 hover:text-fp-primary transition-colors no-underline" @click="$router.push('/about')">About</a>
        <a class="text-sm text-slate-500 hover:text-fp-primary transition-colors no-underline" @click="$router.push({ path: '/about', hash: '#contact' })">Contact</a>
      </div>
      <div class="tw-flex flex-col gap-4">
        <h5 class="text-slate-900 font-semibold">Legal</h5>
        <a class="text-sm text-slate-500 hover:text-fp-primary transition-colors no-underline" target="_blank" href="https://datascouts.eu/privacypolicy">Privacy Policy</a>
        <a class="text-sm text-slate-500 hover:text-fp-primary transition-colors no-underline" target="_blank" href="https://datascouts.eu/termsandconditions">Terms of Service</a>
      </div>
    </div>
    <div class="max-w-7xl mx-auto px-8 mt-16 pt-8 border-t border-slate-200">
      <p class="text-sm text-slate-600">© 2026 Foodleap. All rights reserved.</p>
    </div>
  </footer>
</template>

<script>
  import Container from '../Container/Container.vue'
  import TranslationsMixin from '../../util/TranslationsMixin'
  import { trackHeapEvent } from '../../util/analytics.js'
  import UiMixin from '../../util/UiMixin.js'

  export default {
    computed: {},
    methods: {
      trackHeapEvent,
    },
    mixins: [
      UiMixin,
      TranslationsMixin,
    ],
    components: {
      Container,
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../../scss/variables";

  $spacing: 30px;

  .simplified-footer {
    margin-top: 4rem;
    background: rgba(218, 225, 218, 1);
    font-size: 12px;
  }

  .simplified-footer__content {
    color: white;
    line-height: 1.5;
    padding: 15px 15px 15px 38px;
    display: flex;
    justify-content: space-between;

    a {
      color: white;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .simplified-footer__top {
    display: flex;

    .logo__container {
      display: flex;
      justify-content: left;

      &:first-child {
        margin-bottom: 10px;
      }

      &:last-child {
        margin-top: 10px;
      }
    }
  }

  .simplified-footer__logo_image {
    min-height: 40px;
    width: 200px;
    background-repeat: no-repeat;
    background-position: left;
    background-size: contain;
  }

  .simplified-footer__bottom__middle {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
  }

  .simplified-footer__bottom__middle {
    padding: calc($spacing / 2);
    flex-grow: 1;

    & > div {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;

      a {
        color: #21244A;
      }
    }
  }

  .simplified-footer__bottom {
    display: flex;
  }

  @media screen and (max-width: $screen-md) {
    .simplified-footer__logo_image {
      background-position: center;
    }

    .simplified-footer__top {
      flex-wrap: wrap;

      .logo__container {
        justify-content: center;
      }
    }

    .simplified-footer__bottom {
      display: block;
    }

    .simplified-footer__top__left, .simplified-footer__bottom__middle {
      width: 100%;
      text-align: center;
      margin: 0 auto;
      justify-content: center;
      flex-grow: 1;
    }

    .simplified-footer__content {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
  }
</style>
